// Autogenerated file
export const platformNewsItemGradesEnum = {
    None: "None",
    Like: "Like",
    Dislike: "Dislike",
};
export const platformNewsItemGrades = [
    { label: "Нет оценки", value: "None" },
    { label: "Нравится", value: "Like" },
    { label: "Не нравится", value: "Dislike" },
];
